import { useEffect, useState, type JSX, type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'
import { useClientAuthStore, waitForClientAuthHydration } from '../../store/clientAuthStore.js'

interface RequireClientAuthProps {
  children: ReactNode
}

export default function RequireClientAuth({ children }: RequireClientAuthProps): JSX.Element {
  const [hydrated, setHydrated] = useState(false)
  const user = useClientAuthStore((s) => s.user)
  const location = useLocation()

  useEffect(() => {
    let active = true
    waitForClientAuthHydration().then(() => {
      if (active) setHydrated(true)
    })
    return () => {
      active = false
    }
  }, [])

  if (!hydrated) {
    return <div className="p-4 text-sm text-gray-500">Loading...</div>
  }

  if (!user) {
    return <Navigate to='/client-portal/login' state={{ from: location.pathname }} replace />
  }

  return <>{children}</>
}
